import { TextLargeParagraphTitle } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

export type LearnMoreTileProps = {
  children: ReactNode;
  text: string;
  link: string;
};

export const LearnMoreTile = ({ children, text, link }: LearnMoreTileProps) => {
  return (
    <a
      className="border border-ds-natural-150 rounded-lg hover:shadow-ds-sm cursor-pointer grow basis-0 overflow-hidden"
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <div
        role="img"
        aria-label="article image"
      >
        {children}
      </div>
      <div className="p-3 border-t border-ds-natural-150">
        <TextLargeParagraphTitle
          label={text}
          color="text-ds-natural-600"
        />
      </div>
    </a>
  );
};
